'use strict';
const focusHelper = require('base/components/focus');
import { addClass, hasClass, toggleClass, queryAll, queryFirst, remove, removeClass, renderFragment, toFormData, setAttribute } from '../domUtil';
import { refreshPdpSetGalleryTabIndexes } from '../components/pdpSwiperSlider';
import { clearUserPaused, syncPdpGalleryVideos } from '../components/pdpVideoInView';
import { formatMessage, getJSON, getNestedValue, tokenize, setUrlParamValue } from '../util';
import { getAddToCartAnalyticsData } from './helper';
import { setWishlistProductId, showStrikeHearts } from '../wishlist/helper';
import { EMPTY_STRING, NOT_AVAILABLE_STATUS, SELECTED_CLASS, HIDDEN_CLASS, PDP_MODEL_INFO_BANNER } from '../constants';
import { changeActiveDataDataParams, updatePromoBlockContent } from '../helpers/productHelper';
const { ensureFreshCsrfToken } = require('../utils/csrfRefresh');

const { trackPageView } = require('../components/etmc');
const { toggleSelectSizeInfo, isEarlyAccessElement, isTierEligibleForEarlyAccess } = require('./helper');
const { swatchNameTemplate, sizeOptionTemplate, sizeButtonTemplate, gwpSizeTemplate, dialogTemplate, loyalty: loyaltyTemplates } = require('../templates');
const $body = $('body');
const gwpDialog = queryFirst('#chooseBonusProductModal');
const $gwpDialog = $(gwpDialog);
const readyClass = 'ready-to-add';
const selectedProductClass = 'selected-product';
const notAvailable = 'not-available';
// Toggles the "Please select a size" hint on a bonus tile.
const NO_SIZE_ERROR_CLASS = 'no-sz';
const { updateVisibilityOfLowInventoryMsg } = require('../components/shippingPreference/shippingPreferenceHelper');
const { PRODUCT_DETAIL_CONTAINER_SELECTOR } = require('../components/shippingPreference/constants');
const loyaltyProfile = getNestedValue(window, 'lillyUtils.profile') || {};
const { isLoyaltyProgramMember, isLoyaltyAuthenticated, isLoyaltyEnabled } = loyaltyProfile;
const { videoInnerContent } = require('lilly/templates');
const { initVideos } = require('../components/video').default;
const EXPANDED_CLASS = 'm-expanded';

let observer;
let isContentModulesFetched = false;

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').attr('data-pid');
    } else if ($('.quickview-container').length && !$('.product-set').length) {
        pid = $($el).closest('.quickview-container').find('.product-quickview').attr('data-pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').first().text();
    } else if ($('.custom-set-detail-modal').length) {
        $($el).closest('.custom-set-detail-modal').find('.product-id').first().text();
    } else {
        pid = $($el).closest('.product-detail').find('.product-id').first().text();
    }

    return pid;
}

/**
 * Updates the PDP Club Lilly points text after product changes.
 * @param {Object} data - Variation response with product model
 * @param {HTMLElement} productContainer - Product detail container
 */
function updatePointsIndicator(data, productContainer) {
    const { product } = data;
    const pointsContainer = queryFirst('.js-pdp-clublilly', productContainer);
    const pointsElement = queryFirst('.pdp-points-indicator', productContainer);
    const canShowPoints = isLoyaltyEnabled && isLoyaltyAuthenticated && isLoyaltyProgramMember;
    if (!pointsContainer) return;

    const canShow = product.isDirectlyPurchasable !== false
        && !(product.earlyAccess?.isEarlyAccessProduct && !product.earlyAccess?.isTierEligible);
    const pointsText = product.pointsToEarn || '';
    if (canShowPoints && pointsElement) {
        pointsElement.textContent = pointsText;
    }

    if (pointsText && canShow !== false) {
        removeClass(pointsContainer, HIDDEN_CLASS);
    } else {
        addClass(pointsContainer, HIDDEN_CLASS);
    }
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    return $el && $('.set-items').length ? $el.closest('.product-detail').find('.quantity-select') : $('.quantity-select');
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        const { bonusVariationUrl, url } = attrValue;

        if (isChoiceOfBonusProducts) {
            if (bonusVariationUrl) {
                $swatchButton.attr('data-url', bonusVariationUrl);
            } else {
                $swatchButton.removeAttr('data-url');
            }
        } else if (url) {
            $swatchButton.attr('data-url', url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    if ($productContainer.hasClass('bonus-product-item')) {
        const sizes = attr.values;
        const sizeContainer = queryFirst('.selected-size-container', $productContainer[0]);
        if (!sizes.length || !sizeContainer) {
            return;
        }

        if (sizes.length === 1) {
            sizeContainer.innerHTML = formatMessage(gwpSizeTemplate.singleSize, sizes[0].displayValue);
        } else {
            const loopStatus = sizeContainer.dataset.loopStatus;
            const resetUrl = attr.resetUrl;
            const selectLabel = sizeContainer.dataset.selectLabel;
            const selectId = `bonus-size-${loopStatus.count || '1'}`;

            let sizeOptions = formatMessage(gwpSizeTemplate.multiDefaultSizeOption, resetUrl, selectLabel);
            sizeOptions += sizes
                .map(function (size) {
                    const selected = size.selected ? ' selected ' : '';
                    const className = !size.inStock || size.forceOutOfStock ? notAvailable : '';
                    return formatMessage(gwpSizeTemplate.multiSizeOption, size.url, size.value, selected, size.displayValue, className, className ? 'disabled' : '');
                })
                .join('');
            sizeContainer.innerHTML = formatMessage(gwpSizeTemplate.multiSize, selectId, sizeOptions);
        }
    } else {
        var $attr = '[data-attr="' + attr.id + '"]';
        const selectSizeEl = $productContainer.find('.select-size')[0];
        let selectedValue = '';
        if (selectSizeEl) {
            $(selectSizeEl).find('option').not(':first').remove();
            $(selectSizeEl).find('option:first').attr('value', attr.resetUrl);
        }
        attr.values.forEach(function (attrValue) {
            if (selectSizeEl) {
                const assistiveElement = queryFirst('.selected-assistive-text', selectSizeEl.closest('.size-list'));
                assistiveElement.textContent = selectSizeEl.selectedOptions[0].dataset.attrValue;
                if (!attrValue.isOffline) {
                    selectSizeEl.innerHTML += sizeOptionTemplate(attrValue.url, attrValue.value);
                }
                if (attrValue.selected) {
                    selectedValue = attrValue.value;
                }
            } else {
                var $attrValue = $productContainer.find($attr + ' [data-attr-value="' + attrValue.value + '"]');
                $attrValue.attr('data-variation-id', attrValue.variantID);
                const sizeListItemEl = $attrValue.closest('.size-list');
                if (!attrValue.isOffline) {
                    sizeListItemEl.removeClass(HIDDEN_CLASS);
                } else {
                    sizeListItemEl.addClass(HIDDEN_CLASS);
                }
                if ($attrValue.length > 0) {
                    $attrValue.val(attrValue.url).attr('data-attr-url', attrValue.url).removeClass(notAvailable);
                    const assistiveElement = queryFirst('.selected-assistive-text', $attrValue[0].closest('.size-list'));
                    const { selectedText, outOfStock } = assistiveElement.dataset;
                    if (!attrValue.inStock || attrValue.forceOutOfStock) {
                        $attrValue.addClass(notAvailable);
                        assistiveElement.textContent = outOfStock;
                    } else if (hasClass($attrValue[0], 'selected')) {
                        assistiveElement.textContent = selectedText;
                    } else {
                        assistiveElement.textContent = '';
                    }
                }
            }
        });
        if (selectSizeEl && selectedValue) {
            const optionEl = queryFirst('[data-attr-value="' + selectedValue + '"]', selectSizeEl);
            if (optionEl) {
                optionEl.selected = true;
            } else {
                selectSizeEl.selectedIndex = 0;
            }
        }
    }
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    const { isDirectlyPurchasable } = response.product;
    const availabilityMsgEl = queryFirst('.availability-msg', $productContainer[0]);
    if (isDirectlyPurchasable === false && availabilityMsgEl) {
        availabilityValue = `<li><p class="availability-message-text" role="alert">${availabilityMsgEl.dataset.notPurchasable}</p></li>`;
    } else if (response.product.readyToOrder) {
        availabilityMessages.forEach(function (message) {
            availabilityValue += `<li><p class="availability-message-text" role="alert">
                ${message}
                </p></li>`;
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': ' + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} options - Ajax response options from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(options, $productContainer) {
    options.forEach(function (option) {
        var $optionEl = $productContainer.find('.product-option[data-option-id*="' + option.id + '"]');
        option.values.forEach(function (value) {
            var valueEl = $optionEl.find('option[data-value-id*="' + value.id + '"]');
            valueEl.val(value.url);
        });
    });
}

/**
 * Updates the standard badge for a product
 * @param {Object} productContainer - DOM container for a given product
 * @param {Object} productBadge - Product badge object containing badgeText and badgeTextColor
 * @param {boolean} isEarlyAccessItem - Flag indicating if the product is an early access item
 */
function updateStandardBadge(productContainer, productBadge, isEarlyAccessItem) {
    const standardBadge = queryFirst('.js-buy-box .js-badge', productContainer);

    if (!standardBadge || isEarlyAccessItem) {
        return;
    }
    // Hide and reset badges on initial load
    const badgeTextElement = queryFirst('.product-tile-badge-text', standardBadge);

    addClass(standardBadge, HIDDEN_CLASS);
    badgeTextElement.removeAttribute('style');
    badgeTextElement.textContent = '';

    // If productBadge is defined and has badgeText, update the badge text and color
    if (productBadge?.badge?.length) {
        badgeTextElement.setAttribute('style', `color: ${productBadge.badgetextcolor || 'inherit'}`);
        badgeTextElement.textContent = productBadge.badge;
        removeClass(standardBadge, HIDDEN_CLASS); // Show badge
    }
}

/**
 * Update the product name and descriptions based on the selected variation group
 * @param {Object} productContainer - DOM container for a given product
 * @param {Object} productInfo - Product information object containing variant details
 * @param {Object} currentElementDataSet - Data attributes from the current element
 *
 */
function updateProductNameAndDescriptions(productContainer, productInfo, currentElementDataSet) {
    const { productName, shortDescription, longDescription } = productInfo;
    const { includeLillyColor = 'false', lillyColorName } = currentElementDataSet;

    // update the product name if it is available
    const productNameContainers = queryAll('.js-product-name-container', productContainer);
    if (productNameContainers.length && productName) {
        productNameContainers.forEach(container => {
            container.innerHTML = productName;
        });
    }

    // update the short-description in case if it is available
    const shortDescriptionContainer = queryFirst('.js-short-description-container', productContainer);
    if (shortDescriptionContainer && shortDescription) {
        shortDescriptionContainer.innerHTML = shortDescription;
    }

    // update the long-description based on selected variation group in case if it is available
    // the long description also should be updated with specific color in case if it contains special token
    const longDescriptionElement = queryFirst('.long-description-container .long-description', productContainer);
    if (longDescriptionElement) {
        let description;
        // If the long description is not available in the productInfo, use the data attribute value
        const longDescriptionBase = longDescription || longDescriptionElement.dataset.longDescription;
        if (includeLillyColor !== 'false' && lillyColorName) {
            description = tokenize(longDescriptionBase, { lillyColor: lillyColorName }, '{{', '}}');
        } else {
            description = tokenize(longDescriptionBase, { lillyColor: '' }, '<li>{{', '}}</li>');
        }
        longDescriptionElement.innerHTML = description;
    }
}

/**
 * Swaps the Early Access / Annual Member Gift labels to match the selected variation group.
 * Both label variants are rendered server-side as data attributes.
 * @param {HTMLElement} productContainer - DOM element for current product
 * @param {HTMLElement} earlyAccessCta - Early access restricted CTA block
 * @param {boolean} isAnnualMemberGift - Whether the selected VG is an Annual Member Gift
 */
function updateEarlyAccessEventLabels(productContainer, earlyAccessCta, isAnnualMemberGift) {
    const wantAmg = !!isAnnualMemberGift;
    const labelKey = wantAmg ? 'labelAmg' : 'labelEa';
    const badgeKey = wantAmg ? 'productBadgeAmg' : 'productBadgeEa';

    (queryAll('.js-loyalty-badge-text', productContainer) || []).forEach(badgeTextEl => {
        const label = badgeTextEl.dataset[labelKey];
        if (label) {
            badgeTextEl.textContent = label;
        }
    });

    const buttons = (queryAll('.early-access-sign-in', earlyAccessCta) || []).concat(queryAll('.add-to-cart', productContainer) || []);
    buttons.forEach(button => {
        const label = button.dataset[labelKey];
        const productBadge = button.dataset[badgeKey];
        if (label) {
            button.textContent = label;
        }
        if (productBadge !== undefined) {
            button.dataset.productBadge = productBadge;
        }
    });
}

/**
 * Handles the CTAs to be shown for Early Access Product
 * @param {HTMLElement} productContainer - DOM element for current product
 * @param {boolean} isEarlyAccessProduct - Is the product Early Access Product
 * @param {HTMLElement|null} productContainerEarlyAccessIcon - Early access icon container
 * @param {boolean} isTierEligible - Whether the current user's tier is eligible for this product
 * @param {boolean} [isAnnualMemberGift] - Whether the selected VG is Annual Member Gift
 */
function handleEarlyAccessCta(productContainer, isEarlyAccessProduct, productContainerEarlyAccessIcon, isTierEligible, isAnnualMemberGift) {
    const earlyAccessLockIcon = productContainerEarlyAccessIcon || queryAll('.pdp-details-header .loyalty-early-access-lock-container', productContainer);
    const earlyAccessWishlistIcon = productContainerEarlyAccessIcon ? queryAll('.pdp-details-header .pdp-wish-list', productContainerEarlyAccessIcon.parentElement) : queryAll('.pdp-details-header .pdp-wish-list', productContainer);
    const earlyAccessCta = queryFirst('.loyalty-early-access-restricted', productContainer);
    const addToCartCta = queryFirst('.add-to-cart', productContainer);
    const earlyAccessPdpEl = queryAll('.pdp-badge .js-loyalty-badge', productContainer);
    const lockContainers = productContainerEarlyAccessIcon
        ? [productContainerEarlyAccessIcon]
        : queryAll('.pdp-details-header .loyalty-early-access-lock-container', productContainer);

    if (typeof isAnnualMemberGift === 'boolean') {
        const { updateEarlyAccessLockTooltip } = require('../popover');
        lockContainers.forEach(lockContainer => {
            updateEarlyAccessLockTooltip(lockContainer, isAnnualMemberGift);
        });
    }

    let elements;
    if (isLoyaltyEnabled && earlyAccessCta) {
        if (earlyAccessPdpEl) {
            addClass(earlyAccessPdpEl, HIDDEN_CLASS);
        }
        if (isEarlyAccessProduct) {
            if (isTierEligible) {
                addClass(earlyAccessLockIcon, HIDDEN_CLASS);
                elements = earlyAccessWishlistIcon;
                elements.push(addToCartCta);
                removeClass(elements, HIDDEN_CLASS);
            } else {
                removeClass(earlyAccessLockIcon, HIDDEN_CLASS);
                elements = earlyAccessWishlistIcon;
                elements.push(addToCartCta);
                addClass(elements, HIDDEN_CLASS);

                const earlyAccessGuest = queryFirst('.early-access-guest', earlyAccessCta);
                const earlyAccessRegistered = queryFirst('.early-access-registered', earlyAccessCta);
                if (isLoyaltyAuthenticated) {
                    addClass(earlyAccessGuest, HIDDEN_CLASS);
                    if (isLoyaltyProgramMember) {
                        // INELIGIBLE_TIER — already a member but wrong tier, hide both CTAs.
                        addClass(earlyAccessRegistered, HIDDEN_CLASS);
                    } else {
                        // NON_MEMBER — authenticated but not a loyalty member, show join CTA.
                        removeClass(earlyAccessRegistered, HIDDEN_CLASS);
                    }
                } else {
                    // GUEST — show sign-in CTA.
                    removeClass(earlyAccessGuest, HIDDEN_CLASS);
                    addClass(earlyAccessRegistered, HIDDEN_CLASS);
                }
            }
            // Update message text from data attributes, using the copy set of the event
            // (Early Access or Annual Member Gift) the selected variation group belongs to
            const titleEl = queryFirst('.loyalty-early-access-title', earlyAccessCta);
            const bodyEl = queryFirst('.loyalty-early-access-text', earlyAccessCta);
            const { dataset } = earlyAccessCta;
            const isAmgEvent = typeof isAnnualMemberGift === 'boolean'
                ? isAnnualMemberGift
                : dataset.isAnnualMemberGift === 'true';
            dataset.isAnnualMemberGift = isAmgEvent ? 'true' : 'false';
            const msgTitle = isAmgEvent ? dataset.amgMsgTitle : dataset.msgTitle;
            const msgGuest = isAmgEvent ? dataset.amgMsgGuest : dataset.msgGuest;
            const msgNonMember = isAmgEvent ? dataset.amgMsgNonMember : dataset.msgNonMember;
            const msgIneligibleTier = isAmgEvent
                ? earlyAccessCta.getAttribute('data-amg-msg-ineligible-tier')
                : earlyAccessCta.getAttribute('data-msg-ineligible-tier');
            const msgEligible = isAmgEvent ? dataset.amgMsgEligible : dataset.msgEligible;

            updateEarlyAccessEventLabels(productContainer, earlyAccessCta, isAmgEvent);

            if (titleEl && msgTitle) {
                titleEl.textContent = msgTitle;
            }
            if (bodyEl) {
                let msgBody;
                if (!isLoyaltyAuthenticated) {
                    msgBody = msgGuest;
                } else if (!isLoyaltyProgramMember) {
                    msgBody = msgNonMember;
                } else {
                    msgBody = isTierEligible ? msgEligible : msgIneligibleTier;
                }
                if (msgBody) bodyEl.textContent = msgBody;
            }
            removeClass(earlyAccessCta, HIDDEN_CLASS);
            if (earlyAccessPdpEl) {
                removeClass(earlyAccessPdpEl, HIDDEN_CLASS);
            }
        } else {
            elements = earlyAccessWishlistIcon;
            elements.push(addToCartCta);
            removeClass(elements, HIDDEN_CLASS);
            addClass(earlyAccessLockIcon, HIDDEN_CLASS);
            addClass(earlyAccessCta, HIDDEN_CLASS);
        }
    }
}
/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of product images, along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
* @param {Object|null} earlyAccess - Early access data from `product.earlyAccess`, or null if unavailable.
 * @param {string} productId - Id of the product, used for ID attribute construction
 * @param {string} videoUrl - Selected variant group video url
 * @param {string} videoPosterImage - Selected variant group video poster image url
 * @param {string} [modelInfoCopy] - Model sizing copy for the selected variation group
 * @param {number} [modelInfoBannerImageIndex] - Zero-based image index for the model info banner
 * @param {number} [videoSlideIndex] - Zero-based index at which to insert the video slide
 */
function createCarousel(imgs, $productContainer, earlyAccess, productId, videoUrl, videoPosterImage, modelInfoCopy, modelInfoBannerImageIndex, videoSlideIndex) {
    const isEarlyAccess = !!(earlyAccess && earlyAccess.isEarlyAccessProduct);
    const isTierEligible = isTierEligibleForEarlyAccess(earlyAccess);
    const productContainerEl = $productContainer[0];
    const carouselEls = queryAll('.js-swiper-main, .js-swiper-modal-thumbs, .js-swiper-modal-description, .js-swiper-modal', productContainerEl);
    const mainCarousel = queryFirst('.js-swiper-main', productContainerEl);

    carouselEls.forEach(carouselEl => {
        const { imageType, cache } = carouselEl.dataset;
        const { swiper } = carouselEl;
        const slideEls = queryAll('.swiper-slide', carouselEl);
        const count = imgs?.large.length || 0;
        const galleryClasses = {
            0: 'm-no-images',
            1: 'm-single-image',
            2: 'm-no-controls'
        };

        removeClass(mainCarousel, 'm-no-images', 'm-single-image', 'm-no-controls');

        if (count < 3) {
            addClass(mainCarousel, galleryClasses[count]);
        }

        let cacheParam = `${cache === 'true' ? '&cache_img=true' : ''}`;
        let slideTpl = '';
        let slideInnerTpl = '';
        let linkTagOpen = '';
        let linkTagClose = '';
        let src = '';

        let updatedImages = imgs[imageType];
        // Only in this case we need to make img obj with common structure
        // PDP: { imageScene7: 'generidURL', srcset: '[{"breakpoint": "2x"}]' ...}
        // PDPSet: { url: 'fullURL', srcset: 'prepairedSrcSet' ... }
        if (imgs[imageType][0]?.imageScene7 !== undefined) {
            updatedImages = normalizeImagesObject(imgs[imageType]);
        }

        slideEls.forEach(slideEl => {
            slideEl.remove();
        });

        updatedImages.forEach((updatedImage, index) => {
            if (hasClass(carouselEl, 'js-swiper-modal-description')) {
                slideInnerTpl = updatedImage.title;
            } else {
                if (imageType === 'extralarge') {
                    linkTagOpen = `<button
                                    data-toggle="modal"
                                    type="button"
                                    class="pdp-gallery-popup-trigger"
                                    data-backdrop="false"
                                    data-target="#pdp-lightbox-modal-${productId}"
                                    aria-haspopup="dialog"
                                    aria-controls="pdp-lightbox-modal-${productId}"
                                    tabindex="0"
                                    data-index="${index}"
                                    aria-label="Open image gallery, image ${index + 1} of ${updatedImages.length}. Click to zoom"
                                    >`;
                    linkTagClose = `</button>`;
                    src = `${updatedImage.url}${cacheParam}`;
                } else if (imageType === 'extrasmall') {
                    src = `${updatedImage.url}${cacheParam}`;
                } else if (imageType === 'full') {
                    const { image, preset } = carouselEl.dataset;
                    src = `${updatedImage.url.replace(preset, image)}${cacheParam}`;
                }

                if (Object.keys(updatedImage.sources).length !== 0) {
                    const sourceTags = Object.entries(updatedImage.sources)
                        .map(([key, srcset]) => {
                            return `<source srcset="${srcset}" media="${updatedImage.breakpoints[key]}">`;
                        })
                        .join('');

                    slideInnerTpl = `<picture>
                        ${sourceTags}
                        <img
                        loading="lazy"
                        src="${src || updatedImage.url}"
                        alt="${updatedImage.alt} image number ${index + 1}"
                        title="${updatedImage.title}"
                        itemprop="image"/>
                    </picture>`;
                } else {
                    slideInnerTpl = `<img
                    srcset="${updatedImage.srcset}"
                    src="${src || updatedImage.url}"
                    class="d-block img-fluid w-100"
                    loading="lazy"
                    alt="${updatedImage.alt} image number ${index + 1}"
                    itemprop="image"
                    />`;
                }
            }

            slideTpl += `<div class="swiper-slide">${linkTagOpen}${slideInnerTpl}${linkTagClose}</div>`;
        });

        queryFirst('.swiper-wrapper', carouselEl).innerHTML = slideTpl;

        const baseVideoTemplate = queryFirst('.product-video-template');

        if (videoUrl) {
            baseVideoTemplate.innerHTML = '';
            // eslint-disable-next-line require-jsdoc, no-inner-declarations
            function addVideoComponent(container, poster, url) {
                const videoWrapper = document.createElement('div');
                videoWrapper.className = 'swiper-slide video-carousel-item';
                videoWrapper.setAttribute('role', 'option');
                videoWrapper.innerHTML = videoInnerContent(poster, url);
                container.appendChild(videoWrapper);
            }

            const poster = videoPosterImage || imgs.large[0].imageScene7 + imgs.large[0].url;
            addVideoComponent(baseVideoTemplate, poster, videoUrl);

            const videoTemplate = baseVideoTemplate.cloneNode(true);
            const templateVideoElement = queryFirst('.swiper-slide video', videoTemplate);
            if (templateVideoElement) {
                addClass(templateVideoElement, 'cloned-video');

                if (hasClass(carouselEl, 'js-swiper-main')) {
                    const imageCount = updatedImages.length;
                    let insertIndex = typeof videoSlideIndex === 'number' ? videoSlideIndex : imageCount;
                    if (insertIndex < 0) insertIndex = 0;
                    if (insertIndex > imageCount) insertIndex = imageCount;

                    const wrapper = queryFirst('.swiper-wrapper', carouselEl);
                    const videoSlide = queryFirst('.swiper-slide', videoTemplate);
                    const refSlide = wrapper.children[insertIndex];
                    if (refSlide) {
                        wrapper.insertBefore(videoSlide, refSlide);
                    } else {
                        wrapper.appendChild(videoSlide);
                    }
                    queryFirst('.swiper-slide video', carouselEl).load();
                }
            }

            baseVideoTemplate.innerHTML = '';
            initVideos(templateVideoElement.parentElement);

            const videoComponent = queryFirst('.video-carousel-item .video-component', carouselEl);
            if (videoComponent) {
                clearUserPaused(videoComponent);
                syncPdpGalleryVideos(productContainerEl);
            }
        }

        if (hasClass(carouselEl, 'js-swiper-main') && modelInfoCopy) {
            const imageSlides = queryAll('.swiper-slide:not(.video-carousel-item)', carouselEl);
            const bannerContainer = imageSlides.length === 1
                ? carouselEl
                : imageSlides[modelInfoBannerImageIndex ?? 0];

            if (bannerContainer) {
                const banner = document.createElement('div');
                banner.className = `primary-images-modelinfo ${PDP_MODEL_INFO_BANNER.slice(1)}`;
                banner.setAttribute('aria-live', 'polite');
                banner.textContent = modelInfoCopy;
                bannerContainer.appendChild(banner);
            }
        }

        if (swiper) {
            swiper.slideTo(0);
            swiper.updateProgress();
            swiper.updateSize();
            swiper.updateSlides();
            swiper.update();

            const pdpMain = carouselEl.closest('.pdp .primary-images');

            if (pdpMain) {
                if (swiper.slides.length < 5) {
                    addClass(pdpMain, EXPANDED_CLASS);
                } else {
                    removeClass(pdpMain, EXPANDED_CLASS);
                }
            }
        }

        if (hasClass(carouselEl, 'js-swiper-main') && carouselEl.closest('.product-set-detail')) {
            refreshPdpSetGalleryTabIndexes(carouselEl);
        }
    });

    handleEarlyAccessCta(productContainerEl, isEarlyAccess, null, isTierEligible, !!(earlyAccess && earlyAccess.isAnnualMemberGift));

    const firstImageElement = queryFirst('.swiper-wrapper .swiper-slide img.img-fluid', productContainerEl);
    if (firstImageElement) {
        firstImageElement.addEventListener('load', () => {
            $body.trigger('product:imageLoad', {
                container: productContainerEl
            });
        });
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    const { variationAttributes, productType, readyToOrder, bonusVariationAtrributes, isFinalSale, isDirectlyPurchasable, earlyAccess, badgeData, excludeFromAllPromotions, excludeFromPromotions } = response.product;
    const saleMessageEl = queryFirst('.on-sale-message', $productContainer[0]);
    if (saleMessageEl) {
        if (isFinalSale) {
            removeClass(saleMessageEl, HIDDEN_CLASS);
        } else {
            addClass(saleMessageEl, HIDDEN_CLASS);
        }
    }

    if (isChoiceOfBonusProducts) {
        if (bonusVariationAtrributes) {
            updateAttrs(bonusVariationAtrributes, $productContainer, response.resources);
        }
        if (productType === 'variant') {
            $productContainer.data('ready-to-order', readyToOrder);
        }
    } else if (variationAttributes) {
        updateAttrs(variationAttributes, $productContainer, response.resources);
        if (isDirectlyPurchasable === false) {
            const sizeElements = queryAll('.size-btn', $productContainer[0]);
            addClass(sizeElements, notAvailable);
        }
    }

    const productContainer = $productContainer[0];
    // Check if the product is early access
    const isEarlyAccessItem = isEarlyAccessElement(earlyAccess);
    if (isChoiceOfBonusProducts) {
        // LP customization changes start
        const { alt, url, srcset } = response.product.images.extrasmall[0] || {};
        const productImageElement = queryFirst('.product-image', productContainer);
        productImageElement.setAttribute('src', url);
        productImageElement.setAttribute('srcset', srcset);
        productImageElement.setAttribute('alt', alt);
        // LP customization changes end
    } else {
        setAttribute(queryFirst('.modal.js-pdp-lightbox-modal', $productContainer[0]), 'id', 'pdp-lightbox-modal-' + response.product.id);
        createCarousel(
            response.product.images,
            $productContainer,
            earlyAccess,
            response.product.id,
            response.product.videoFile,
            response.product.videoPosterImage,
            response.product.modelInfoCopy,
            response.product.modelInfoBannerImageIndex,
            response.product.videoSlideIndex
        );
    }

    // Update the standard badge based on the product badge and early access status
    updateStandardBadge(productContainer, badgeData, isEarlyAccessItem, excludeFromAllPromotions, excludeFromPromotions);
    // Updated logic here
    const swatchNameElement = queryFirst('.selected-swatch-name', productContainer);
    const selectedSwatch = queryFirst('.swatch-circle.selected', productContainer);
    const selectedSwatchElement = queryFirst('.selected-swatch', productContainer);
    let selectedSwatchName = '';
    let selectedSwatchData = {};

    if (selectedSwatch) {
        if (selectedSwatchElement) {
            const { colorLabel } = selectedSwatchElement.dataset;
            if (colorLabel) {
                selectedSwatchName += colorLabel;
            }
        }

        const { swatchName } = selectedSwatch.dataset;

        selectedSwatchName += swatchName;
        selectedSwatchData = selectedSwatch.parentElement.dataset;
    }

    if (swatchNameElement) {
        swatchNameElement.textContent = selectedSwatchName;
    } else {
        const swatchHtml = formatMessage(swatchNameTemplate.swatchNameHtml, selectedSwatchName);
        if (selectedSwatchElement) {
            selectedSwatchElement.innerHTML = swatchHtml;
        }
    }

    // update the product name and descriptions based on selected variation group
    updateProductNameAndDescriptions(productContainer, response.product, selectedSwatchData);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        let $priceSelector = $('.prices .price', $productContainer);
        if (!$priceSelector.length) $priceSelector = $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    // As there was no changes inside the PR #13482 for exclusion messages for some product items, the false flag is send
    updatePromoBlockContent(response.product.promotions, productContainer, excludeFromPromotions, excludeFromAllPromotions, response.product.showGWPPromoIcon);

    const promotionsPopover = queryFirst('.promotions-info-popover .promotions-info-popover-content');
    $('.custom-set-detail').find('.promotions-info').popover({
        trigger: 'click',
        placement: 'bottom',
        html: true,
        content: promotionsPopover
    });
    $('[data-toggle="popover"]')
        .off('shown.bs.popover')
        .on('shown.bs.popover', function (e) {
            var target = e.target;
            $(document).one('click', function (clickEvent) {
                var clicked = clickEvent.target;
                if (clicked !== target && clicked.parentElement !== target) {
                    $(target).trigger('click');
                }
            });
        });

    updateAvailability(response, $productContainer);
    // triger event to update the store inventory message and store data after attribute selection
    $body.trigger('product:updateStoreInventory', { productContainer });

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product,
            $productContainer: $productContainer
        });
    } else if ($productContainer.closest('#productSetModal').length > 0) {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart-global, button.update-cart-product-global')
            .trigger('product:updateAddToCart', {
                product: response.product,
                $productContainer: $productContainer
            })
            .trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty().html(getAttributesHtml(response.product.attributes));
}

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if (!$productContainer.hasClass('.bonus-product-item')) {
        var optionsHtml = quantities
            .map(function (quantity) {
                var selected = quantity.selected ? ' selected ' : '';
                return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' + selected + '>' + quantity.value + '</option>';
            })
            .join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {Object} selectedSizeElement - DOM element for selected size button
 */
async function attributeSelect(selectedValueUrl, $productContainer, selectedSizeElement) {
    if (selectedValueUrl) {
        $body.trigger('product:beforeAttributeSelect', {
            url: selectedValueUrl,
            container: $productContainer
        });

        // Updated logic here
        const $choiceOfBonusProductEl = $productContainer.closest('.choice-of-bonus-product');
        if ($choiceOfBonusProductEl.length) {
            $productContainer.spinner().start();
        }

        try {
            const res = await fetch(selectedValueUrl);
            if (!res.ok) throw new Error('response was not OK');
            const data = await res.json();

            handleVariantResponse(data, $productContainer);
            updateOptions(data.product.options, $productContainer);
            updateQuantities(data.product.quantities, $productContainer);
            $body.trigger('product:afterAttributeSelect', {
                data: data,
                container: $productContainer,
                selectedSizeElement
            });
            if ($choiceOfBonusProductEl.length) {
                // Sync the DOM data-pid attr (not just jQuery's .data() cache) —
                // Cart-AddBonusProducts reads it via dataset and needs the resolved variant id.
                $productContainer[0].dataset.pid = data.product.id;
                $choiceOfBonusProductEl.trigger('bonus:afterAttributeSelect');
            }
        } catch (err) {
            console.error(`base error: ${err.message}`);
        } finally {
            if ($choiceOfBonusProductEl.length) {
                $productContainer.spinner().stop();
            } else {
                $.spinner().stop();
            }
        }
    }
}

/**
 * add size parameter to the Product-Variation call if it is 'set-items' page
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @returns {string|boolean} url with size parameter
 */
function addSizeParamForSetItems(selectedValueUrl, $productContainer) {
    const selectedSizeElement = queryFirst('.js-set-items .size-btn.selected', $productContainer[0]);
    if (!selectedSizeElement || !selectedValueUrl) return false;

    const masterId = $productContainer[0]?.dataset.masterid;
    const selectedSizeValue = selectedSizeElement?.dataset.attrValue;
    if (!masterId || !selectedSizeValue) return false;

    const isSizeExist = selectedValueUrl.indexOf('_size') !== -1;
    const sizeParamName = isSizeExist ? '_size' : `dwvar_${masterId}_size`;
    return setUrlParamValue(selectedValueUrl, sizeParamName, selectedSizeValue, isSizeExist);
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function selectColorAttribute(selectedValueUrl, $productContainer, contextEl) {
    if (selectedValueUrl) {
        $body.trigger('product:beforeAttributeSelect', {
            url: selectedValueUrl,
            container: $productContainer
        });

        // Updated logic here
        const $choiceOfBonusProductEl = $productContainer.closest('.choice-of-bonus-product');
        if ($choiceOfBonusProductEl.length) {
            $productContainer.spinner().start();
        }

        // add 'size' parameter if it is 'set-items' page
        selectedValueUrl = addSizeParamForSetItems(selectedValueUrl, $productContainer) || selectedValueUrl;

        const stopSpinner = () => {
            if ($choiceOfBonusProductEl.length) {
                $productContainer.spinner().stop();
            } else {
                $.spinner().stop();
            }
        };

        getJSON(
            selectedValueUrl,
            'GET',
            null,
            data => {
                try {
                    const { options, quantities, uuid } = data.product;
                    handleVariantResponse(data, $productContainer);
                    updateOptions(options, $productContainer);
                    updateQuantities(quantities, $productContainer, uuid);
                    const selectedSizeElement = queryFirst('.size-btn.selected', $productContainer[0]);
                    $body.trigger('product:afterAttributeSelect', {
                        data: data,
                        container: $productContainer,
                        selectedSizeElement
                    });
                    if ($choiceOfBonusProductEl.length) {
                        const sizeEl = queryFirst('.select-size', $choiceOfBonusProductEl[0]);
                        if (sizeEl) sizeEl.selectedIndex = 0;
                        // Sync data-pid attr — see attributeSelect for rationale.
                        $productContainer[0].dataset.pid = data.product.id;
                        $choiceOfBonusProductEl.trigger('bonus:afterAttributeSelect');
                    }
                    const swatchContainer = queryFirst('.color-container', $productContainer[0]);
                    const assistiveElements = queryAll('.selected-assistive-text', swatchContainer);
                    const selectedSwatchElement = queryFirst('.swatch-circle.selected', $productContainer[0]);
                    const assistiveTextElement = selectedSwatchElement
                        && queryFirst('.selected-assistive-text', selectedSwatchElement.closest('.color-list'));
                    assistiveElements.forEach(eachElement => {
                        eachElement.textContent = '';
                    });
                    if (assistiveTextElement) {
                        assistiveTextElement.textContent = assistiveTextElement.dataset.selectedText;
                    }

                    updatePointsIndicator(data, $productContainer[0]);

                    const productContainerEl = $productContainer[0];
                    const masterId = productContainerEl.dataset.masterid;
                    const colorBtn = contextEl?.closest?.('.color-attribute') || contextEl;
                    const variantKey = colorBtn?.dataset?.attrValue;
                    const variantData = masterId && variantKey && window.productInfo?.[masterId]?.variants?.[variantKey];

                    if (variantData) {
                        updatePrintCategory(variantData.printCategory, productContainerEl, colorBtn);
                    }
                } catch (err) {
                    console.error(`base error: ${err.message}`);
                } finally {
                    stopSpinner();
                }
            },
            () => {
                stopSpinner();
            }
        );
    }
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} data - Shop the print data
 * @param {Object} productContainer - DOM container for a given product
 */
function updateShopThePrint(data, productContainer) {
    const shopThePrintElement = queryFirst('.shop-the-print', productContainer);
    if (shopThePrintElement) {
        if (data) {
            shopThePrintElement.outerHTML = data;
        } else {
            shopThePrintElement.outerHTML = '<div class="shop-the-print"></div>';
        }
    }
}
/**
 * Process attribute values associated with an print category
 * @param {Object} data - Shop the print data
 * @param {Object} productContainer - DOM container for a given product
 * @param {HTMLElement} [contextEl] - Element that triggered the update (e.g. color swatch)
 */
function updatePrintCategory(data, productContainer, contextEl) {
    const scope = contextEl?.closest?.('.pdp-details') || productContainer;
    const container = queryFirst('.js-printcategory', scope);

    if (!container) {
        return;
    }

    const isDataAvailable = !!data?.id;

    toggleClass(container, HIDDEN_CLASS, !isDataAvailable);

    const printCategoryLink = queryFirst('a', container);
    const printCategoryText = queryFirst('span', container);

    if (printCategoryLink) {
        printCategoryLink.href = data?.url || '';
    }

    if (printCategoryText) {
        printCategoryText.textContent = data?.name || '';
    }
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {int} price - product sale price
 * @param {int} standardPrice - product standard price
 * @param {Object} productContainer - DOM container for a given product
 * @param {int} percentOff - percent off value
 */
function updateProductPrice(price, standardPrice, productContainer, percentOff) {
    const priceTemplate = document.getElementById('price-template').cloneNode(true);
    const priceSection = queryFirst('.prices .price', productContainer);
    const buybarPriceSection = queryFirst('.pdp-buybar-price .price');
    const priceContainer = queryFirst('.price-section', priceTemplate);
    const strikeThroughContainer = queryFirst('.strike-through-section', priceContainer);
    const priceElement = queryFirst('.strike-through-price', strikeThroughContainer);
    const salesContainer = queryFirst('.sales', priceContainer);
    const salesPriceElement = queryFirst('.price-value', salesContainer);
    const percentOffContainer = percentOff && queryFirst('.percent-off', priceContainer);
    let fixedPrice = price;
    let fixedStandardPrice = standardPrice;

    // Fix decimal places for non-whole-number prices
    if (price % 1 !== 0) {
        fixedPrice = price.toFixed(2);
    }
    if (standardPrice % 1 !== 0) {
        fixedStandardPrice = standardPrice.toFixed(2);
    }

    removeClass(strikeThroughContainer, HIDDEN_CLASS);
    priceElement.textContent = `$${fixedStandardPrice}`;
    salesPriceElement.textContent = `$${fixedPrice}`;
    if (price === standardPrice) {
        addClass(strikeThroughContainer, HIDDEN_CLASS);
    }

    // add/change percent off value on PDP
    const template = percentOffContainer && percentOffContainer.dataset.template;
    if (percentOffContainer && percentOff && template) {
        percentOffContainer.textContent = template.replace('{0}', percentOff);
        removeClass(percentOffContainer.parentElement, HIDDEN_CLASS);
    } else if (percentOffContainer) {
        addClass(percentOffContainer.parentElement, HIDDEN_CLASS);
    }

    priceSection.innerHTML = priceTemplate.innerHTML;
    buybarPriceSection.innerHTML = priceTemplate.innerHTML;
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} sizes - sizes object
 * @param {Object} productContainer - DOM container for a given product
 * @param {Object} variantsList - Variations list data
 */
function updateSizeElements(sizes, productContainer, variantsList) {
    const masterId = productContainer.dataset.masterid;
    const isQuickView = hasClass(productContainer, 'cached-quick-view');
    const { variants } = isQuickView ? window.quickviewProductInfo.productInventory : window.productInventory[masterId];
    const sizeContainer = queryFirst('.size-container', productContainer);

    if (!sizeContainer) return;

    const { selectedText, outOfStock, label, describedby, attrValue } = sizeContainer.dataset;
    let sizeButtonHtml = '';

    variantsList.forEach((eachVariant, index) => {
        const eachSize = sizes[eachVariant];
        const sizeElement = queryFirst('[data-attr="size"] [data-attr-value="' + eachVariant + '"]', productContainer);
        const sizeId = eachSize.ID;
        const { forceOutOfStock } = eachSize;
        const inventoryData = variants[sizeId];
        const variantData = {
            value: eachVariant,
            forceOutOfStock,
            selected: sizeElement ? hasClass(sizeElement, SELECTED_CLASS) : false,
            inStock: inventoryData.availabilityStatus !== NOT_AVAILABLE_STATUS && !inventoryData.isBackOrder,
            sizeId: sizeId
        };
        const ariaLabelValue = label + ' ' + attrValue + ' ' + eachVariant;
        sizeButtonHtml += sizeButtonTemplate(variantData, ariaLabelValue, describedby + eachVariant + index, selectedText, outOfStock, variantsList.length);
    });

    remove(queryAll('.size-list', sizeContainer));
    sizeButtonHtml += sizeContainer.innerHTML;
    sizeContainer.innerHTML = sizeButtonHtml;

    // Ensure only one size button per group is tabbable (roving tabindex)
    const sizeButtons = queryAll('.size-btn[role="radio"]', sizeContainer) || [];
    if (sizeButtons.length) {
        let current = sizeButtons.find(btn => hasClass(btn, SELECTED_CLASS));
        if (!current) {
            current = sizeButtons.find(btn => !hasClass(btn, notAvailable)) || sizeButtons[0];
        }

        sizeButtons.forEach(btn => {
            const isActive = btn === current;
            btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
            btn.tabIndex = isActive ? 0 : -1;
        });
    }
}

/**
 * updates image urls and presets by appending the scene7 url
 * @param {Object} images - images array to be updated
 * @returns {Object} - updated images array
 */
function normalizeImagesObject(images) {
    return images.map(imageObj => {
        const srcsetPresets = JSON.parse(imageObj.srcset);
        const mediaSources = JSON.parse(imageObj.sources);
        const breakpoints = JSON.parse(imageObj.breakpoints);
        let srcsetString = [];
        let sources = {};

        mediaSources.forEach(source => {
            Object.keys(source).forEach(breakpointKey => {
                if (!breakpoints[breakpointKey]) {
                    return;
                }
                const resolutions = source[breakpointKey];
                if (!resolutions || !Array.isArray(resolutions)) {
                    return;
                }
                const sourceString = resolutions
                    .map(resolution => {
                        const [scale, value] = Object.entries(resolution)[0];
                        return `${imageObj.imageScene7}?${value}${scale === '1x' ? '' : ` ${scale}`}`;
                    })
                    .join(', ');

                sources[breakpointKey] = sourceString;
            });
        });

        srcsetPresets.forEach(function (source) {
            if (Object.prototype.hasOwnProperty.call(source, 'all')) {
                source.all.forEach(function (item) {
                    Object.entries(item).forEach(function ([scale, value]) {
                        srcsetString.push(`${imageObj.imageScene7}?${value}${scale === '1x' ? '' : ` ${scale}`}`);
                    });
                });
            }
        });

        return {
            alt: imageObj.alt,
            url: imageObj.imageScene7 + imageObj.url,
            srcset: srcsetString.join(', '),
            title: imageObj.title,
            sources: sources,
            breakpoints
        };
    });
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {Object} currentElement - selected color element
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateProductDetails(currentElement, $productContainer) {
    const { initPopoverPromotions, initPopoverClose } = require('../popover');
    const elementData = currentElement.dataset;
    const variantGroupId = elementData.attrValue;
    const productContainer = $productContainer[0];
    const swatchNameElement = queryFirst('.selected-swatch-name', productContainer);
    const swatchContainer = queryFirst('.color-container', productContainer);
    const assistiveElements = queryAll('.selected-assistive-text', swatchContainer);
    const assistiveTextElement = queryFirst('.selected-assistive-text', currentElement.closest('.color-list'));
    const monogramBtn = queryFirst('.pdp-monogram-btn', productContainer);
    const masterId = productContainer.dataset.masterid;
    const productInfo = window.productInfo[masterId];
    const {
        groupId,
        sizes,
        images,
        shopThePrint,
        price,
        standardPrice,
        percentOff,
        videoUrl,
        variantsList,
        mgFlag,
        mgLocs,
        isFinalSale,
        isDirectlyPurchasable,
        earlyAccess,
        promotions,
        showGWPPromoIcon,
        videoPosterImage,
        activeData,
        badgeData,
        printCategory,
        pointsToEarn,
        excludeFromPromotions,
        excludeFromAllPromotions,
        modelInfoCopy,
        modelInfoBannerImageIndex,
        videoSlideIndex
    } = productInfo.variants[variantGroupId];

    productContainer.dataset.wishlistId = groupId;
    setWishlistProductId(groupId, productContainer);
    const colorElements = queryAll('.color-attribute .swatch-circle', productContainer);
    const { attrDisplayvalue, customPageTitle, pageTitle, includeLillyColor, lillyColorName, customPageDescription, pageDescription } = elementData;
    const titleElement = queryFirst('.meta-page-title');
    const descriptionElement = queryFirst('.meta-page-description');
    // update Marketing Analytics trackWishlist event
    let marketingCloudPageAnalytics = [{ item: groupId }];
    trackPageView(marketingCloudPageAnalytics);
    // Updated logic here
    if (swatchNameElement) {
        const selectedSwatchElement = queryFirst('.selected-swatch', productContainer);
        const colorlabel = selectedSwatchElement.dataset.colorLabel;
        swatchNameElement.textContent = colorlabel + attrDisplayvalue;
    } else {
        const swatchHtml = formatMessage(swatchNameTemplate.swatchNameHtml, attrDisplayvalue);
        queryFirst('.selected-swatch', productContainer).innerHTML = swatchHtml;
    }

    changeActiveDataDataParams(productContainer, activeData);

    if (customPageTitle && titleElement) {
        titleElement.textContent = customPageTitle;
    } else if (pageTitle && titleElement) {
        titleElement.textContent = pageTitle;
    }

    // update the product name and descriptions based on selected variation group
    updateProductNameAndDescriptions(productContainer, productInfo.variants[variantGroupId], currentElement.dataset);

    if (customPageDescription && descriptionElement) {
        descriptionElement.content = customPageDescription;
    } else if (pageDescription && descriptionElement) {
        descriptionElement.content = pageDescription;
    }

    removeClass(colorElements, 'selected');
    addClass(queryFirst('.swatch-circle', currentElement), 'selected');
    queryFirst('.product-id', productContainer).textContent = masterId;
    setAttribute(queryFirst('.modal.js-pdp-lightbox-modal', productContainer), 'id', 'pdp-lightbox-modal-' + currentElement.dataset.attrValue);

    assistiveElements.forEach(eachElement => {
        eachElement.textContent = '';
    });

    assistiveTextElement.textContent = assistiveTextElement.dataset.selectedText;

    if (mgFlag && mgLocs && mgLocs.length > 0) {
        removeClass(monogramBtn, HIDDEN_CLASS);
    } else {
        addClass(monogramBtn, HIDDEN_CLASS);
    }

    updateSizeElements(sizes, productContainer, variantsList);

    $body.trigger('product:updateStoreInventory', {
        productContainer
    });
    if (!isDirectlyPurchasable) {
        const sizeElements = queryAll('.size-btn', productContainer);
        addClass(sizeElements, notAvailable);
    }
    updateShopThePrint(shopThePrint, productContainer);
    updateProductPrice(price, standardPrice, productContainer, percentOff);
    updatePrintCategory(printCategory, productContainer, currentElement);

    updatePointsIndicator({
        product: {
            pointsToEarn,
            isDirectlyPurchasable,
            earlyAccess
        }
    }, productContainer);

    const productFinalSaleMessage = queryFirst('.on-sale-message', productContainer);
    const productFreeReturnsMessage = queryFirst('.pdp-header-promo');
    const percentOffContainer = percentOff && queryFirst('.percent-off', productContainer);

    if (productFinalSaleMessage) {
        if (isFinalSale) {
            removeClass(productFinalSaleMessage, HIDDEN_CLASS);
            addClass(productFreeReturnsMessage, 'd-none');
            if (percentOff) addClass(percentOffContainer.parentElement, HIDDEN_CLASS);
        } else {
            addClass(productFinalSaleMessage, HIDDEN_CLASS);
            removeClass(productFreeReturnsMessage, 'd-none');
        }
    }

    const ssSizeElement = queryFirst('.size-btn.selected', productContainer);

    if (!ssSizeElement) {
        $('.availability-msg', $productContainer).empty();
        removeClass(queryFirst('.pdp-attribute-name', productContainer), 'm-error');
        // Update promotion block content
        updatePromoBlockContent(promotions, productContainer, excludeFromPromotions, excludeFromAllPromotions, showGWPPromoIcon);

        // pick new promotion popover elements
        initPopoverPromotions();
        initPopoverClose();

        // Update ISPU link with VG when size is not yet selected -- ensures we only check stock for the VG variants.
        const ispuBtn = queryFirst('.btn-in-store-pickup', productContainer);
        if (ispuBtn && groupId) ispuBtn.dataset.pid = groupId;
    }
    // Check if the product is early access
    const isEarlyAccessItem = isEarlyAccessElement(earlyAccess);
    // Create the carousel with the updated images and handle early access buttons and badges
    createCarousel(images, $productContainer, earlyAccess, variantGroupId, videoUrl, videoPosterImage, modelInfoCopy, modelInfoBannerImageIndex, videoSlideIndex);
    // Update the standard badge based on the product badge and early access status
    updateStandardBadge(productContainer, badgeData, isEarlyAccessItem);
    // Trigger events after attribute change
    $body.trigger('product:afterAttributeChange', {
        container: $productContainer,
        variantGroupId,
        groupId
    });
    $body.trigger('product:handleImageZoom');
    const wishlistButton = queryFirst('.add-to-wish-list', productContainer);
    if (wishlistButton && hasClass(wishlistButton, 'added-to-wish-list')) {
        removeClass(wishlistButton, 'added-to-wish-list');
        wishlistButton.disabled = false;
        const assistiveText = wishlistButton.getAttribute('data-assistive-text');
        wishlistButton.setAttribute('aria-label', assistiveText);
    }
    // Updated logic here
    const swatchParam = `?dwvar_${masterId}_color`;
    const queryParams = location.search;
    let UpdatedParams = `${swatchParam}=${variantGroupId}`;
    if (queryParams) {
        UpdatedParams = queryParams
            .split('&')
            .map(eachParam => {
                if (eachParam.indexOf(swatchParam) > -1) {
                    return `${swatchParam}=${variantGroupId}`;
                }
                return eachParam;
            })
            .join('&');
    }
    history.replaceState({ variantGroupId }, document.title, UpdatedParams);
}

/**
 * updates the quick view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {Object} currentElement - selected color element
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateQuickViewDetails(currentElement, $productContainer) {
    const elementData = currentElement.dataset;
    const variantGroupId = elementData.attrValue;
    const productContainer = $productContainer[0];
    const swatchNameElement = queryFirst('.selected-swatch-name', productContainer);
    const swatchContainer = queryFirst('.color-container', productContainer);
    const assistiveElements = queryAll('.selected-assistive-text', swatchContainer);
    const assistiveTextElement = queryFirst('.selected-assistive-text', currentElement.closest('.color-list'));
    const quickViewInfo = window.quickviewProductInfo;
    const { productInfo } = quickViewInfo;
    const { groupId, sizes, images, price, standardPrice, variantsList, isDirectlyPurchasable, pdpBreadCrumbs, earlyAccess, videoUrl, videoPosterImage, modelInfoCopy, modelInfoBannerImageIndex, videoSlideIndex } = productInfo.variants[variantGroupId];
    productContainer.dataset.wishlistId = groupId;
    setWishlistProductId(groupId, productContainer);
    handleEarlyAccessCta(productContainer, earlyAccess && earlyAccess.isEarlyAccessProduct, null, isTierEligibleForEarlyAccess(earlyAccess), !!(earlyAccess && earlyAccess.isAnnualMemberGift));
    const colorElements = queryAll('.color-attribute .swatch-circle', productContainer);
    const { attrDisplayvalue } = elementData;
    // Updated logic here
    if (swatchNameElement) {
        swatchNameElement.textContent = attrDisplayvalue;
    } else {
        const swatchHtml = formatMessage(swatchNameTemplate.swatchNameHtml, attrDisplayvalue);
        queryFirst('.selected-swatch', productContainer).innerHTML = swatchHtml;
    }
    removeClass(colorElements, 'selected');
    addClass(queryFirst('.swatch-circle', currentElement), 'selected');

    assistiveElements.forEach(eachElement => {
        eachElement.textContent = '';
    });

    assistiveTextElement.textContent = assistiveTextElement.dataset.selectedText;

    updateSizeElements(sizes, productContainer, variantsList);
    if (!isDirectlyPurchasable) {
        const sizeElements = queryAll('.size-btn', productContainer);
        addClass(sizeElements, notAvailable);
    }

    updateProductPrice(price, standardPrice, productContainer);
    const ssSizeElement = queryFirst('.size-btn.selected', productContainer);

    if (!ssSizeElement) {
        $('.availability-msg', $productContainer).empty();
        removeClass(queryFirst('.pdp-attribute-name', productContainer), 'm-error');
    }

    const isEarlyAccessItem = isEarlyAccessElement(earlyAccess);
    createCarousel(images, $productContainer, earlyAccess, variantGroupId, videoUrl, videoPosterImage, modelInfoCopy, modelInfoBannerImageIndex, videoSlideIndex);
    $body.trigger('product:quickViewAttributeChange', {
        container: $productContainer,
        variantGroupId,
        groupId,
        productContainer,
        monetateData: {
            pdpBreadCrumbs
        }
    });
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    const $html = $('<div>').append($.parseHTML(html));

    const body = $html.find('.choose-gwp-sheet-gift');
    const selectedProducts = $html.find('.selected-products-container');
    const footer = $html.find('.modal-footer');

    return {
        body,
        footer,
        selectedProducts
    };
}

/**
 * Function to update GWP elements on swatch or size change
 */
function updateGwpElements() {
    $('.choice-of-bonus-product').on('bonus:afterAttributeSelect', function () {
        const productDialog = queryFirst('.choose-bonus-product-dialog');
        const accordionContainer = this.closest('.choose-gwp-sheet-gift', productDialog);
        const bonusAccordionElements = queryAll('.choose-gwp-sheet-gift', productDialog);
        const addToCart = queryFirst('.add-bonus-products', productDialog);
        const sizeEl = queryFirst('.size-selection', this);
        const selectedSize = queryFirst('.size-btn.selected', sizeEl);
        const isOneSize = queryFirst('.selected-size', sizeEl);
        const selectedSwatchCircle = queryFirst('.color-attribute .swatch-circle.selected', this);
        const isSelectedSizeUnavailable = hasClass(selectedSize, notAvailable);
        const isSizeSelected = !!isOneSize || (sizeEl ? !!selectedSize : true);
        const isStateValid = isSizeSelected && !!selectedSwatchCircle && !isSelectedSizeUnavailable;

        if (isSelectedSizeUnavailable) {
            addClass(sizeEl, notAvailable);
        } else {
            removeClass(sizeEl, notAvailable);
        }

        // Any attribute swap = user is iterating; clear the size-required hint.
        removeClass(this, NO_SIZE_ERROR_CLASS);

        // Uncheck a previously confirmed gift if the new combination is invalid.
        const checkbox = queryFirst('.select-bonus-product', this);
        if (checkbox && checkbox.checked && !isStateValid) {
            checkbox.click();
        }

        const maxItems = parseInt(accordionContainer.dataset.maxItems, 10) || 1;
        const selectedItemsCount = queryAll('.select-bonus-product:checked', accordionContainer).length;
        const isReady = isStateValid && selectedItemsCount >= maxItems;

        if (isReady) {
            addClass(accordionContainer, readyClass);
        } else {
            removeClass(accordionContainer, readyClass);
        }

        const validProducts = queryAll('.choose-gwp-sheet-gift.ready-to-add', productDialog);
        addToCart.disabled = !isReady || hasClass(addToCart, notAvailable) || bonusAccordionElements.length !== validProducts.length;

        // Forward to legacy bonus:updateSelection. Handler branches on size-btn
        // vs js-color-attribute target, so pass whichever is currently selected.
        const target = selectedSize
            || (selectedSwatchCircle && selectedSwatchCircle.closest('.js-color-attribute'));
        $body.trigger('bonus:updateSelection', { target });
    });
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
async function chooseBonusProducts(data) {
    const $spinner = $('.choose-bonus-product-dialog').spinner();
    $spinner.start();

    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    const { maxBonusItems, addToCartUrl, uuid, pliUUID, pageSize, showProductsUrlRuleBased, bonusChoiceRuleBased, bonusDiscountLineItems } = data;
    $('.choose-bonus-product-dialog').attr({
        'data-total-qty': maxBonusItems,
        'data-addToCartUrl': addToCartUrl,
        'data-UUID': uuid,
        'data-pliUUID': pliUUID,
        'data-pageStart': 0,
        'data-pageSize': pageSize,
        'data-moreURL': showProductsUrlRuleBased,
        'data-bonusChoiceRuleBased': bonusChoiceRuleBased,
        'data-bonus-items': JSON.stringify(bonusDiscountLineItems)
    });

    const sheetHeaderText = queryFirst('.choose-gwp-sheet-subtitle', gwpDialog);
    if (sheetHeaderText) sheetHeaderText.textContent = data.labels.selectprods;

    try {
        const res = await fetch(bonusUrl);
        if (!res.ok) throw new Error('response was not OK');
        const data = await res.json();

        const parsedHtml = parseHtml(data.renderedTemplate);
        const enterMessage = queryFirst('.enter-message', gwpDialog);

        if (enterMessage) enterMessage.textContent = data.enterDialogMessage;
        $gwpDialog.find('.choose-gwp-sheet-select').html(parsedHtml.body);
        $gwpDialog.find('.choose-gwp-sheet-footer-submit, .selected-products-container').remove();
        $gwpDialog.find('.choose-gwp-sheet-footer').append(parsedHtml.footer.removeClass('modal-footer').addClass('choose-gwp-sheet-footer-submit'));
        $(parsedHtml.selectedProducts).insertAfter($gwpDialog.find('.choose-gwp-sheet-subtitle'));
        // LP custom changes start
        const { selectedBonusProducts } = data;
        if ((selectedBonusProducts || []).length) {
            const modalDialog = queryFirst('.choose-bonus-product-dialog');
            let selectedProductsCount = 0;
            selectedBonusProducts.forEach(eachProductList => {
                if (eachProductList.length) {
                    const bonusAccordionContainer = queryFirst(`.choose-gwp-sheet-gift[data-uuid="${eachProductList[0].uuid}"]`, modalDialog);
                    const maxCount = parseInt(bonusAccordionContainer.dataset.maxItems, 10);
                    const productListLength = eachProductList.length;
                    if (maxCount === productListLength) {
                        addClass(bonusAccordionContainer, 'selected');
                        addClass(bonusAccordionContainer, readyClass);
                    }
                    const bonusItemCount = queryFirst('.bonus-item-count span', bonusAccordionContainer);
                    if (bonusItemCount) bonusItemCount.textContent = productListLength;
                    selectedProductsCount += productListLength;
                    eachProductList.forEach(eachProduct => {
                        const selectedProduct = queryFirst(`.choice-of-bonus-product[data-pid="${eachProduct.pid}"][data-uuid="${eachProduct.uuid}"]`);
                        const selectBonusCheckbox = queryFirst('.select-bonus-product', selectedProduct);

                        if (selectBonusCheckbox) {
                            selectBonusCheckbox.checked = true;
                        }

                        addClass(selectedProduct, selectedProductClass);
                    });
                }
            });
            const addToCart = queryFirst('.add-bonus-products', modalDialog);
            addToCart.disabled = maxBonusItems !== selectedProductsCount;
        }

        // Default all size dropdowns that aren't selected products
        $('.bonus-product-item:not(.selected-product) .select-size').each(function () {
            this.selectedIndex = 0;
        });

        updateGwpElements();
        // LP custom changes end
        $gwpDialog.modal('show');
        $spinner.stop();
    } catch (err) {
        console.error(`choose gwp error: ${err.message}`);
        $spinner.stop();
    }
}

let errorTimeout;
/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    if (!response.error) {
        return;
    }

    if (response.displayModal) {
        let addToCartWarningDialog = queryFirst('#add-to-cart-warning-dialog');

        if (!addToCartWarningDialog) {
            const isOnCartPage = window.location.pathname === '/cart/';
            const fragment = renderFragment(
                dialogTemplate({
                    buttons: isOnCartPage ? [{ text: 'OK', primary: true }] : [{ text: 'Close' }, { text: 'Review Tote', primary: true, link: response.redirectLink }],
                    modalContentHeading: response.messageHeading,
                    modalContentBody: isOnCartPage ? response.messageBodyOnCart : response.messageBodyOffCart,
                    id: 'add-to-cart-warning-dialog'
                })
            );

            document.body.appendChild(fragment);
            addToCartWarningDialog = queryFirst('#add-to-cart-warning-dialog');
        }

        $(addToCartWarningDialog).modal('show');
    } else {
        const isPDP = queryFirst('.page[data-action="Product-Show"]') || false;
        const messageType = response.error ? 'alert-danger' : 'alert-success';

        if (isPDP) {
            const errorContainer = queryFirst('.js-add-product-errors');
            const headerHeight = queryFirst('header.main-header').offsetHeight;
            const scrollToEl = queryFirst('.pdp-actions')?.getBoundingClientRect().top + window.scrollY;
            const scrollPosition = scrollToEl - headerHeight;

            // Always clear container first (only one message)
            errorContainer.textContent = '';

            const li = document.createElement('li');
            li.textContent = response.message || errorContainer.dataset.oosMessage;
            errorContainer.appendChild(li);

            window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
            });

            // If there is already a pending timeout, cancel it
            if (errorTimeout) {
                clearTimeout(errorTimeout);
            }

            // Schedule new timeout
            errorTimeout = setTimeout(() => {
                errorContainer.textContent = '';
                errorTimeout = null;
            }, 5000);
        } else {
            // show add to cart toast
            remove(queryAll('.add-to-cart-messages'));

            let addToCartMessages = queryFirst('.add-to-cart-messages');
            if (!addToCartMessages) {
                document.body.appendChild(renderFragment('<div class="add-to-cart-messages"></div>'));
                addToCartMessages = queryFirst('.add-to-cart-messages');
            }

            addToCartMessages.appendChild(renderFragment(addToCartAlert(messageType, response.message)));

            setTimeout(() => {
                remove(queryAll('.add-to-basket-alert'));
            }, 5000);
        }
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]').data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        })
        .toArray();

    return JSON.stringify(options);
}

export default {
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },
    attributeSelect,
    updateProductDetails,
    updateImageDetails: normalizeImagesObject,
    focusChooseBonusProductModal: function () {
        $gwpDialog.on('shown.bs.modal', () => {
            $gwpDialog.siblings().attr('aria-hidden', 'true');
            $gwpDialog.attr('aria-hidden', 'false');
            $gwpDialog.find('.close').trigger('focus');

            const sheet = queryFirst('.choose-bonus-product-dialog', gwpDialog);
            sheet?.setAttribute('aria-hidden', 'false');
        });
    },

    onClosingChooseBonusProductModal: function () {
        $gwpDialog.on('hidden.bs.modal', () => {
            $gwpDialog.siblings().attr('aria-hidden', 'false');

            const sheet = queryFirst('.choose-bonus-product-dialog', gwpDialog);
            sheet?.setAttribute('aria-hidden', 'false');
            removeClass(sheet, 'selected');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $body.on('keydown', '#chooseBonusProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button.color-attribute', function (e) {
            e.preventDefault();
            const productDetailContainer = queryFirst(PRODUCT_DETAIL_CONTAINER_SELECTOR);

            if ($(this).attr('disabled') || hasClass(queryFirst('.swatch-circle', this), 'selected')) {
                return;
            }

            const productContainerEl = this.closest('.product-detail, .product-quickview, .gift-card-main, .pdp-container');
            if (productContainerEl) {
                queryAll(PDP_MODEL_INFO_BANNER, productContainerEl).forEach(banner => banner.remove());
            }

            var $productContainer = $(this).closest('.set-items .product-detail, .choose-bonus-product-modal .product-detail, .gift-card-main, .product-quickview');
            if ($productContainer.hasClass('cached-quick-view')) {
                updateQuickViewDetails(this, $productContainer);
            } else if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
                updateProductDetails(this, $productContainer);
            } else {
                selectColorAttribute($(this).attr('data-url'), $productContainer, this);
            }
            $body.trigger('swatchChangeEvent', this);
            $body.trigger('search:updateProducts');
            updateVisibilityOfLowInventoryMsg(productDetailContainer);
        });
    },

    renderSizeElements: function () {
        const swatchEls = queryAll('.pdp-container:not(.gift-card-main) button.color-attribute .swatch-circle.selected, .product-set-item button.color-attribute .swatch-circle.selected');

        swatchEls.forEach(swatchEl => {
            if (swatchEl) {
                const productContainer = swatchEl.closest('.pdp-container, .product-set-item');
                const selectedSizeEl = queryFirst('.size-btn.selected', productContainer);

                if (!selectedSizeEl) {
                    const selectedSwtachBtn = swatchEl.parentElement;
                    const variantGroupId = selectedSwtachBtn.dataset.attrValue;
                    const masterId = productContainer.dataset.masterid;
                    const productInfo = window.productInfo[masterId];
                    const { sizes, variantsList, isDirectlyPurchasable, wishlistDisabled, isFinalSale } = productInfo.variants[variantGroupId];

                    updateSizeElements(sizes, productContainer, variantsList);
                    const sizeElements = queryAll('.size-btn', productContainer);
                    if (!isDirectlyPurchasable) {
                        addClass(sizeElements, notAvailable);
                    }
                    if (wishlistDisabled || !isDirectlyPurchasable || isFinalSale) {
                        showStrikeHearts(productContainer);
                    }

                    // select size if it is 'one-size' product AND 'set-items' page
                    if (sizeElements && sizeElements.length === 1 && hasClass(productContainer, 'js-product-set-item')) {
                        sizeElements[0].click();
                    }
                }

                let savedStoreId = getNestedValue(window, 'lillyUtils.shippingPreferencesConfig.storeId') || EMPTY_STRING;
                let preferredStoreId = getNestedValue(window, 'lillyUtils.shippingPreferencesConfig.preferredStoreId') || EMPTY_STRING;
                const storeId = savedStoreId && savedStoreId !== 'null' ? savedStoreId : preferredStoreId;

                $body.trigger('product:updateStoreInventory', {
                    productContainer: productContainer,
                    storeId
                });
            }
        });
    },

    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            if (!e.target.closest('.fp-root')) {
                e.preventDefault();
                var $productContainer = $(this).closest('.set-item');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.product-detail');
                }
                attributeSelect(e.currentTarget.value, $productContainer);
            }
        });
    },

    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect($(e.currentTarget).find('option:selected').data('url'), $productContainer);
            }
        });
    },

    addToCart: () => {
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', async e => {
            // Elements
            const csrfResult = await ensureFreshCsrfToken();

            const { target } = e;
            const $target = $(target);
            const productContainer = target.closest('.product-detail');
            const $productContainer = $(productContainer);
            const storeLocatorContainer = queryFirst('.pickup-in-store-content', productContainer);
            const ispuAddToCart = queryFirst('.add-to-cart', storeLocatorContainer);
            const ajaxData = queryFirst('.js-ajax-data');
            const csrfToken = ajaxData?.dataset?.csrfTokenValue;

            if (ispuAddToCart) {
                ispuAddToCart.disabled = true;
            }

            const pdpSetData = {};
            let isPDPSet = false;

            // PDP Set - add all to cart button
            if (hasClass(target, 'add-to-cart-global')) {
                isPDPSet = true;
                const setPids = [];

                const setModal = target.closest('.custom-set-detail-modal');
                // all visible set products -- "removed" set products are not included (removed set products do not have the custom-set-product class)
                const modalProducts = queryAll('.custom-set-items.set-items .custom-set-product', setModal);
                const insideShopTheLook = target.closest('.js-shop-the-look');
                // set products which have a selected size
                modalProducts.forEach(modalProduct => {
                    let sizeSelected = queryFirst('.size-btn.selected', modalProduct);
                    // cheking if the product is a shop the look product and checkbox marked
                    if (insideShopTheLook && sizeSelected && !hasClass(target, 'js-add-all-to-tote')) {
                        sizeSelected = queryFirst('.js-select-size-input:checked', sizeSelected.closest('.js-attribute'));
                    }

                    if (sizeSelected) {
                        // collect some data for the ATC call while we're looping anyway
                        setPids.push({
                            pid: queryFirst('.product-id', modalProduct)?.textContent,
                            options: getOptions($(modalProduct))
                        });
                    }
                });

                Object.assign(pdpSetData, {
                    pidsObj: JSON.stringify(setPids)
                });
            } else {
                // Not PDP Set -- Check if size is selected on single product PDP
                toggleSelectSizeInfo(productContainer);
                if (!queryFirst('.size-btn.selected', productContainer)) {
                    return;
                }
            }

            $body.trigger('product:beforeAddToCart', target);

            const analyticsData = getAddToCartAnalyticsData();

            const form = {
                pid: getPidValue($target),
                childProducts: getChildProducts(),
                csrf_token: csrfToken,
                ...pdpSetData,
                ...analyticsData
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $target.trigger('updateAddToCartFormData', form);

            let addToCartUrl = getAddToCartUrl();

            // it needs for cases when mincart has a recommendation block with empty value in the '.add-to-cart-url'
            if (!addToCartUrl && hasClass(productContainer, 'is-stylitics-gallery')) {
                let closestUrl = queryFirst('.add-to-cart-url', productContainer);
                if (closestUrl && closestUrl.value) addToCartUrl = closestUrl.value;
            }

            if (addToCartUrl) {
                let resData;
                try {
                    const res = await fetch(addToCartUrl, {
                        method: 'POST',
                        body: toFormData(form)
                    });

                    resData = await res.json();
                    if (!res.ok) throw new Error('Add to cart response was not OK');

                    if (isPDPSet) {
                        $('#productSetModal').modal('hide');

                        // hide shop the look popup after closing cart
                        const shopTheLookModal = $('#productSetModal-' + $target.data('pid'));
                        if (shopTheLookModal.length) shopTheLookModal.modal('hide');
                    }

                    if (ispuAddToCart) {
                        ispuAddToCart.disabled = false;
                        $productContainer.find('.sheet[id*="pick-up-in-store"]').modal('hide');
                    }

                    handlePostCartAdd(resData);

                    $.spinner().stop();
                    $body.trigger('product:afterAddToCart', resData);

                    // Send AddToCart analytics data to Stylitics
                    const selectedVariationGroup = queryFirst('.js-color-attribute .color-value.selected', productContainer);
                    const { productId: selectedVariationId } = selectedVariationGroup?.closest('button')?.dataset || {};
                    document.body.dispatchEvent(
                        new CustomEvent('stylitics:completeLook:addItemToCart', {
                            detail: {
                                pid: selectedVariationId || form.pid,
                                price: queryFirst('.price-section .sales .ssSalesPrice', productContainer)?.value,
                                placement: 'main',
                                target: 'pdp'
                            },
                            bubbles: true
                        })
                    );

                    // send analytics data (trackAddItemToCart) if it is Stylitics Gallery QuickView on PLP
                    // and Stylitics Gallery Widget exists
                    if (hasClass(productContainer, 'is-stylitics-gallery')) {
                        $body.trigger('stylitics:gallery:addItem', {
                            pid: form.pid,
                            price: queryFirst('.price-section .sales .ssSalesPrice', productContainer)?.value
                        });
                    }
                } catch (err) {
                    $.spinner().stop();
                    if (ispuAddToCart) {
                        ispuAddToCart.disabled = false;
                    }
                    if (resData?.csrfError) {
                        $body.trigger('csrf:error');
                    }
                    console.error('addToCart error:', err.message);
                }
            }
        });
    },
    updateBonusSelection: function () {
        $body.on('bonus:updateSelection', (event, data) => {
            const { target } = data;
            if (!target) return;

            const accordionContainer = target.closest('.choose-gwp-sheet-gift');

            // return, if 'accordionContainer' is not found (ex. Product Set page)
            if (!accordionContainer) return;

            const choiceOfBonusProduct = target.closest('.choice-of-bonus-product');
            const $choiceOfBonusProduct = $(choiceOfBonusProduct);
            const { pid, uuid } = choiceOfBonusProduct.dataset;

            // Scope by pid + uuid so multi-pick tiers don't wipe out other selected gifts.
            remove(queryFirst(`.selected-pid[data-pid="${pid}"][data-uuid="${uuid}"]`));

            const maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            const submittedQty = 1;
            let totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });

            const gwpCheckbox = hasClass(target, 'size-btn') || hasClass(target, 'js-color-attribute') ? queryFirst('.select-bonus-product', $choiceOfBonusProduct[0]) : target;
            const { checked } = gwpCheckbox;
            const productDialog = queryFirst('.choose-bonus-product-dialog');
            const addToCart = queryFirst('.add-bonus-products', productDialog);
            const selectedProductElement = queryFirst(`.selected-pid[data-pid="${pid}"][data-uuid="${uuid}"]`, productDialog);
            let bonusAccordionElements = queryAll('.choose-gwp-sheet-gift', productDialog);
            const bonusCountElement = queryFirst('.bonus-item-count span', accordionContainer);
            const selectedCount = queryAll('.select-bonus-product:checked', accordionContainer).length;
            const maxCount = parseInt(accordionContainer.dataset.maxItems, 10);
            const sizeEl = queryFirst('.size-selection', choiceOfBonusProduct);
            const isOneSize = queryFirst('.selected-size', sizeEl);
            const selectedSizeBtn = queryFirst(`.size-btn.${SELECTED_CLASS}`, sizeEl);
            // A `selected` size button can be flagged `not-available` after a color swap.
            const isSelectedSizeUnavailable = hasClass(selectedSizeBtn, notAvailable);
            const isSizeSelected = (!!selectedSizeBtn && !isSelectedSizeUnavailable) || !!isOneSize;
            let selectedSwatch = queryFirst('.color-attribute .swatch-circle.selected', choiceOfBonusProduct);

            if (selectedCount < maxCount) {
                removeClass(accordionContainer, 'selected');
            } else {
                addClass(accordionContainer, 'selected');
            }
            if (bonusCountElement) bonusCountElement.textContent = selectedCount;

            let enableAddTocart = true;
            const maxItems = parseInt(accordionContainer.dataset.maxItems, 10);
            const selectedItemsCount = queryAll('.select-bonus-product:checked', accordionContainer).length;
            if (selectedItemsCount < maxItems) {
                enableAddTocart = false;
            }
            enableAddTocart = isSizeSelected && !!selectedSwatch && enableAddTocart;

            if (enableAddTocart) {
                addClass(accordionContainer, readyClass);
            } else {
                removeClass(accordionContainer, readyClass);
            }

            let validProducts = queryAll('.choose-gwp-sheet-gift.ready-to-add', productDialog);

            if (!hasClass(addToCart, notAvailable)) {
                addToCart.disabled = bonusAccordionElements.length !== validProducts.length;
            }

            if (checked) {
                addClass(choiceOfBonusProduct, selectedProductClass);
            } else {
                removeClass(choiceOfBonusProduct, selectedProductClass);
                if (selectedProductElement) {
                    selectedProductElement.click();
                }
            }
            if (selectedCount < maxCount) {
                $(accordionContainer).find('.choice-of-bonus-product').find('.select-bonus-product, .color-attribute, select').removeAttr('tabindex');
            } else {
                $(accordionContainer).find('.choice-of-bonus-product:not(.selected-product)').find('.select-bonus-product, .color-attribute, select').attr('tabindex', -1);
            }
            if (!checked) {
                return;
            }

            totalQty += submittedQty;
            const optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            const valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                if (isSizeSelected) {
                    const selectedBonusProductHtml = `
                        <div class="selected-pid row" data-pid="${pid}" data-uuid="${uuid}" data-qty="${submittedQty}" data-optionID="${optionID || ''}" data-option-selected-value="${valueId || ''}">
                            <div class="col-sm-11 col-9 bonus-product-name" >${$choiceOfBonusProduct.find('.product-name').html()}</div>
                            <div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>
                        </div>`;
                    $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                    $('.pre-cart-products').html(totalQty);
                    $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
                }
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },

    selectBonusProduct: function () {
        // Bonus product selection process:
        // - user clicks on the product
        // - this code checks the box and triggers the bonus:updateSelection custom event
        //     - if it is a one-size product, a new HTML structure is appended into a hidden div (.selected-products-container) on the page containing information about the selected product
        //     - if it is not a one-size product, that HTML structure is not added
        //         - upon clicking a size, attributeSelect() is called which fires off an ajax request to get updated product information. The response is then used to
        //           rewrite the size elements on the page.
        //         - a PDP CUSTOM EVENT is triggered (product:afterAttributeSelect from detail.js). The main reason why this is needed is to update the data-pid value on
        //           the .product-detail element on the page (updates to the SKU value corresponding to the selected size).
        //         - the same bonus:updateSelection custom event is then called again, which now sees that a size has been selected. It reads from that updated
        //           data-pid attribute and appends a new HTML structure into a hidden div (.selected-products-container) on the page
        // - upon clicking the add to tote button in the select gwp sheet, the event listener will read the product information from the hidden div (.selected-products-container)
        //   and fire off an ajax request to add the selected products to tote.
        $body.on('click', '.select-bonus-product', function () {
            $body.trigger('bonus:updateSelection', { target: this });
        });

        const bonusDrawer = document.getElementById('chooseBonusProductModal');

        if (bonusDrawer) {
            bonusDrawer.addEventListener('click', e => {
                const { target } = e;
                const isSize = hasClass(target, 'size-btn');
                const isColor = hasClass(target, 'color-value') || hasClass(target, 'js-color-attribute');

                if (hasClass(target, 'bonus-product-item')) {
                    e.preventDefault();
                    const targetCheckbox = queryFirst('.select-bonus-product', target);
                    const parentTier = target.closest('.choose-gwp-sheet-gift');

                    // reset errors for all gifts in this tier
                    removeClass(queryAll('.bonus-product-item', parentTier), NO_SIZE_ERROR_CLASS);

                    if (!targetCheckbox.checked) {
                        const hasSizes = queryFirst('.size-btn', target);
                        const selectedSize = queryFirst('.size-btn.selected', target);
                        // A `selected` size button can also be `not-available` after a
                        // color swap — server keeps the URL-driven selection but flags it OOS.
                        const hasValidSize = selectedSize && !hasClass(selectedSize, notAvailable);

                        if (!hasSizes || hasValidSize) {
                            // For multi-pick tiers, only swap (uncheck oldest) once the
                            // limit is reached; otherwise selections must accumulate.
                            const maxItems = parseInt(parentTier.dataset.maxItems, 10) || 1;
                            const checkedBoxes = queryAll('.select-bonus-product:checked', parentTier);
                            if (checkedBoxes.length >= maxItems) {
                                checkedBoxes[0].click();
                            }
                        } else {
                            addClass(target, NO_SIZE_ERROR_CLASS);
                            return;
                        }
                    }

                    // toggle the checkbox for the clicked tile
                    targetCheckbox.click();
                } else if (isSize || isColor) {
                    const wrapper = target.closest('.product-detail');
                    const checkbox = queryFirst('.select-bonus-product', wrapper);
                    const sheet = wrapper.closest('.choose-gwp-sheet');
                    const sizeEl = queryFirst('.size-selection', wrapper);
                    const isOneSize = queryFirst('.selected-size', sizeEl);
                    const sizeBtns = queryAll('.size-btn', sizeEl);
                    const colorBtn = isColor && (hasClass(target, 'color-value') ? target.closest('.js-color-attribute') : target);
                    const attrUrl = isColor && isOneSize ? colorBtn.dataset.url : target.dataset.attrUrl;
                    const { pid: prevId } = wrapper.dataset;

                    if (isSize) {
                        removeClass(sizeBtns, SELECTED_CLASS);
                        addClass(target, SELECTED_CLASS);
                    }

                    if (checkbox && !checkbox.checked && (isSize || (isColor && isOneSize))) {
                        wrapper.click();
                    }

                    remove(queryFirst(`.selected-pid[data-pid="${prevId}"]`, sheet));

                    attributeSelect(attrUrl, $(wrapper), isColor && isOneSize ? colorBtn : target);
                }
            });
        }
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },
    enableBonusProductSelection: function () {
        $body.on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr('disabled', !response.product.readyToOrder || !response.product.available);
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption = parseInt($(this).data('qty'), 10);
                const pid = $(this).data('pid');
                const uuid = $(this).data('uuid');
                const productId = $(`.choice-of-bonus-product.selected-product[data-pid="${pid}"][data-uuid="${uuid}"]`).attr('data-pid');
                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = productId;
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        uuid: uuid,
                        pid: productId,
                        qty: qtyOption,
                        options: option ? [option] : []
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&bonusItems=' + JSON.stringify($('.choose-bonus-product-dialog').data('bonusItems'));
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $body.append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.add-to-cart-messages').append('<div class="alert alert-danger add-to-basket-alert text-center" role="alert">' + data.errorMessage + '</div>');
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');
                        $('.minicart-quantity').html(data.totalQty);
                        if ($('.cart-page').length) {
                            location.reload();
                        }
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    revealRecommendations: function () {
        const { initSpecificCarousel } = require('../components/carousel');
        queryAll('.recommendations:not(.product-listing-header)').forEach(eachRecommendation => {
            const titleEl = queryFirst('.title', eachRecommendation);
            const productEl = queryFirst('.grid-tile', eachRecommendation);
            const scrollableContent = queryFirst('.scrollable-content', eachRecommendation);

            if (titleEl && !productEl) {
                eachRecommendation.outerHTML = '';
            } else if (titleEl && productEl) {
                eachRecommendation.style.display = 'block';
                if (scrollableContent) initSpecificCarousel(scrollableContent);
            }
        });
    },
    handleEarlyAccessPLPLockIcon: function () {
        const earlyAccessPLPContainer = queryAll('.js-early-access-plp-container');
        if (earlyAccessPLPContainer.length) {
            earlyAccessPLPContainer.forEach(earlyAccessPlpIcon => {
                const lockIconContainer = queryFirst('.loyalty-early-access-lock-container', earlyAccessPlpIcon);
                const earlyAccessWishlistIcon = queryFirst('.product-tile .pdp-wish-list', earlyAccessPlpIcon);
                const earlyAccessPLPBadge = queryFirst('.js-loyalty-badge', earlyAccessPlpIcon);
                const isEarlyAccessItem = isEarlyAccessElement(lockIconContainer.dataset.earlyAccessDate);
                const isTierEligible = lockIconContainer.dataset.isTierEligible === 'true';
                if (isTierEligible || !isEarlyAccessItem) {
                    removeClass(earlyAccessWishlistIcon, HIDDEN_CLASS);
                    addClass(lockIconContainer, HIDDEN_CLASS);
                    if (!isEarlyAccessItem) {
                        addClass(earlyAccessPLPBadge, HIDDEN_CLASS);
                    }
                } else {
                    addClass(earlyAccessWishlistIcon, HIDDEN_CLASS);
                    removeClass([lockIconContainer, earlyAccessPLPBadge], HIDDEN_CLASS);
                }
            });
        }
    },
    initLoyaltyPointsVisibility: function () {
        const pointsContainers = queryAll('.js-pdp-clublilly');
        pointsContainers.forEach(pointsContainer => {
            const messageElement = queryFirst(
                '.pdp-points-indicator, .earn-exclusive-benefits-with-club-lilly-text',
                pointsContainer
            );
            if (!messageElement || !messageElement.textContent.trim()) {
                addClass(pointsContainer, HIDDEN_CLASS);
            }
        });
    },

    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    handleEarlyAccessCta: handleEarlyAccessCta,
    isTierEligibleForEarlyAccess: isTierEligibleForEarlyAccess
};
